<template>
  <Toaster
    position="top-right"
    :duration="5000"
    :toastOptions="{
      classes: {
        toast: 'custom-toast-item',
        title: 'custom-toast-title',
        description: 'custom-toast-description',
        success: 'custom-toast-success',
        error: 'custom-toast-error',
        warning: 'custom-toast-warning',
        info: 'custom-toast-info',
        closeButton: 'custom-toast-close',
      },
    }"
    richColors
    closeButton
  />
</template>

<script setup lang="ts">
import { Toaster } from "vue-sonner";
import "vue-sonner/style.css";
</script>
